/* stylelint-disable selector-max-compound-selectors */
/* cwc-billboard */
$background-color: var(--cwc-billboard-background-color, #f7f4f2) !default;
$progress-bar-background-color: var(--cwc-billboard-progress-bar-background-color-hover, #c30c15) !default;
$arrow-background-color: var(--cwc-billboard-arrow-background-color, #c30c15) !default;
$arrow-background-color-hover: var(--cwc-billboard-arrow-background-color-hover, #a00d0c) !default;
$height: var(--cwc-billboard-height, 400px) !default;

// csc-button
@use '~@cewe-designsystem-stylecomponents/button/button-old/float' as floatButton;

// csc-mixins
@use '~@cewe-designsystem-stylecomponents/mixins/shadows' as shadows;

// csc-breakpoints
@use '~@cewe-designsystem-stylecomponents/mixins/breakpoints' as breakpoints;

:host {
  display: flex;
  position: relative;
  box-sizing: border-box;
  align-items: center;
  width: 100%;
  height: $height;
  transition: opacity 0.3s;
  background-color: $background-color;

  @include breakpoints.breakpoint(sm, 'down') {
    ul {
      display: none !important;
    }
  }

  slot[name='scroll-left-icon'],
  slot[name='scroll-right-icon'] {
    @extend %csc-button-float;

    display: flex;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0;
    background: $arrow-background-color;
    fill: currentColor;
    color: #fff;
  }

  cwc-scrollable {
    --scrollbar-width: 5px;
    --scrollbar-padding: 0;
    --scrollbar-thumb-fill-color: var(--cwc-scrollable-scrollbar-thumb-fill-color, #c30a15);
    --viewport-height: $height;
    --viewport-overflow-y: hidden;
    --viewport-scroll-snap-type: x mandatory;
    --scrollbar-thumb-border-radius: 0;

    width: 100%;
    -webkit-overflow-scrolling: touch;
  }

  cwc-billboard-pictures {
    display: flex;
    width: 100%;
    height: $height;
    overflow: hidden;

    ::slotted(picture) {
      position: relative;
      height: 100%;
      padding: 1rem 0.5rem;
      scroll-snap-align: center;
    }

    ::slotted(picture:first-of-type) {
      padding-left: 1rem;
    }

    ::slotted(picture:last-of-type) {
      padding-right: 1rem;
    }
  }

  cwc-billboard-progress-bar {
    display: flex;
    position: relative;
    bottom: 0;
    height: 5px;
    background-color: $progress-bar-background-color;
  }

  ul {
    display: flex;
    position: absolute;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    pointer-events: none;

    li {
      display: flex;
      position: absolute;
      align-items: center;
      height: 100%;
      pointer-events: all;

      slot[name='scroll-left-icon'] > *,
      slot[name='scroll-right-icon'] > *,
      ::slotted(*) {
        width: 1.4rem;
      }
    }
  }

  li {
    &:hover,
    &:active,
    &:focus {
      slot[name='scroll-left-icon'],
      slot[name='scroll-right-icon'] {
        background: $arrow-background-color-hover;
      }
    }

    &:first-of-type {
      left: 1rem;
    }

    &:last-of-type {
      right: 1rem;
    }

    &[hidden] {
      display: none;
    }
  }
}

/* prevent flickering within default-theme -> earlyGlobal.css */
cwc-billboard:not(.hydrated) {
  min-height: 400px;
  opacity: 0;
}
